<template>
    <div class="container-fluid navless-content-80 d-flex justify-content-center top-bottom-margin pb-0">
        <div class="row align-self-center w-100">
            <div class="col px-0">
                <h2 class='text-center'>添加活动</h2>
                <form class="missionForm">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">活动标题</span>
                        </div>
                        <b-form-input :disabled="this.disableBtn" :state="vTitle" v-model="mission.title" type="text" class="form-control" placeholder="简洁的描述活动核心内容" id="title"></b-form-input>
                        <!-- <input :disabled="this.disableBtn" v-model="mission.title" type="text" class="form-control" id="title" placeholder="简洁的描述活动核心内容"> -->
                    </div>
                    <div class="form-group">
                        <label for="comment"><h5>活动内容:</h5></label>
                            <b-form-textarea
                            :disabled="this.disableBtn"
                            :state="vContent"
                            id="content"
                            v-model="mission.content"
                            rows="8"
                            ></b-form-textarea>
                        <!-- <textarea :disabled="this.disableBtn" v-model="mission.content" class="form-control" rows="8" id="content"></textarea> -->
                        <small class="form-text text-muted" id="passwordHelpBlock">
                            详细介绍活动的内容。(最多140字，还可以写{{wordLeft}}字)
                        </small>
                    </div>
                    <div class="form-group"><h5>活动结束时间:</h5></div>
                    <div class="form-row">
                        <div class="form-group col-4 text-center">
                        <label for="inputYear">年</label>
                        <b-form-input type="number" class="form-control text-center no-icon" id="inputYear" :state="vTime" v-model="year" :disabled="this.disableBtn"></b-form-input>
                        </div>
                        <div class="form-group col-2 text-center">
                        <label for="inputMonth">月</label>
                        <b-form-input type="number" class="form-control text-center no-icon" id="inputMonth" :state="vTime" v-model="month" :disabled="this.disableBtn"></b-form-input>
                        </div>
                        <div class="form-group col-2 text-center">
                        <label for="inputDay">日</label>
                        <b-form-input type="number" class="form-control text-center no-icon" id="inputDay" :state="vTime" v-model="day" :disabled="this.disableBtn"></b-form-input>
                        </div>
                        <div class="form-group col-2 text-center">
                        <label for="inputHour">时</label>
                        <b-form-input type="number" class="form-control text-center no-icon" id="inputHour" :state="vTime" v-model="hour" :disabled="this.disableBtn"></b-form-input>
                        </div>
                        <div class="form-group col-2 text-center">
                        <label for="inputMinute">分</label>
                        <b-form-input type="number" class="form-control text-center no-icon" id="inputMinute" :state="vTime" v-model="minute" :disabled="this.disableBtn"></b-form-input>
                        </div>
                        <div class="form-group col-12 text-center">
                        <label for="goal">活动目标人数</label>
                        <b-form-input type="number" class="form-control text-center no-icon" id="goal" :state="vGoalNum" v-model="mission.goal" :disabled="this.disableBtn"></b-form-input>
                        </div>  
                    </div>
                    <!-- <b-input-group class="mb-2">
                        <b-form-input type="number" class="form-control text-center" id="inputYear" :state="vTime" v-model="year" :disabled="this.disableBtn" placeholder="年"></b-form-input>
                        <b-form-input type="number" class="form-control text-center" id="inputMonth" :state="vTime" v-model="month" :disabled="this.disableBtn" placeholder="月"></b-form-input>
                        <b-form-input type="number" class="form-control text-center" id="inputDay" :state="vTime" v-model="day" :disabled="this.disableBtn" placeholder="日"></b-form-input>
                        <b-form-input type="number" class="form-control text-center" id="inputHour" :state="vTime" v-model="hour" :disabled="this.disableBtn" placeholder="时"></b-form-input>
                        <b-form-input type="number" class="form-control text-center" id="inputMinute" :state="vTime" v-model="minute" :disabled="this.disableBtn" placeholder="分"></b-form-input>
                    </b-input-group>
                    <div class="form-group col-12 text-center px-0">
                        <label for="goal">活动目标人数</label>
                        <b-form-input type="number" class="form-control text-center" id="goal" :state="vGoalNum" v-model="mission.goal" :disabled="this.disableBtn"></b-form-input>
                    </div>   -->

                    <b-row class="w-100 m-0" align-h="between" style="margin:0">
                        <b-col cols="6" style="padding-right:7px;padding-left:0">
                            <b-button block variant="primary" size="lg" @click="submitValidate()" :disabled="this.disableBtn"><b-spinner variant="primary" :class="{'hide':!this.loading}"></b-spinner>提交</b-button>
                        </b-col>
                        <b-col cols="6" style="padding-left:7px;padding-right:0">
                            <b-button block variant="danger" size="lg" @click="cancel()" :disabled="this.disableBtn">取消</b-button>
                        </b-col>
                    </b-row>
                </form>
            </div>
        </div>
    </div>
</template>

<style scoped>
    /* *, *:before, *:after {
        transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
    } */

    input[type=number]::-webkit-inner-spin-button,
    
    input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    .no-icon {
        background-image: none !important;
        padding-right: 0.75rem !important;
    }
</style>

<script>
import {store} from '../components/store'
import {auth} from '../components/auth'
import {urls} from '../components/urls'

export default {
    name:'dispatch',
    mixins: [auth,urls],
    data:function(){
        return {
            mission:{
                title:'',
                content:'',
                date:'',
                goal:2
            },
            year:0,
            month:0,
            day:0,
            hour:0,
            minute:0,
            date:'',
            loading:false,
            disableBtn:false,
            success:false,
            submitPressed:false,
            test:new Date('2011-04-11T10:20:30Z')
        }
    },
    methods: {
        cancel:function(){
            this.$router.back();
        },
        submitValidate:function(){
            this.submitPressed=true;
            if(this.vTitle && this.vContent && this.vTime && this.vGoalNum) this.submitCampaign();
            // this.submitCampaign();
        },
        submitCampaign:function(){
            this.disableBtn=true;
            const header = `${this.userInfo.mail} ${this.userInfo.password}`;
            this.mission.date=this.inputDate;
            this.$axios.post(this.fetchUrl+"/api/campaigns",this.mission,{headers: { "Authorization" : header}})
            .then(res=>{
                let json=res.data;
                if(!json.error){
                    alert("success");
                    this.success=true;
                    this.$router.push({path:'/campaigns',replace:true});
                }else{
                    alert("fail");
                }
                this.disableBtn=false;
            })
            .catch(error => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
                this.disableBtn=false;
            });
        }
    },
    computed:{
        inputDate(){
            let date='';
            date+=this.year+'-';
            if(this.month.length==1)date+='0';
            date+=this.month+'-';
            if(this.day.length==1)date+='0';
            date+=this.day+' ';
            if(this.hour.length==1)date+='0';
            date+=this.hour+':';
            if(this.minute.length==1)date+='0';
            date+=this.minute+':00';
            return date
        },
        test1(){
            return new Date(this.year,this.month,this.day,this.hour,this.minute);
        },
        vTitle(){
            if(!this.submitPressed){
                return null
            }
            if(this.mission.title.trim() === ''){
                return false 
            }
            return true
        },
        vContent(){
            if(!this.submitPressed){
                return null
            }
            if(this.mission.content.trim() === '' || this.mission.content.length > 150){
                return false 
            }
            return true
        },
        vTime(){
            if(!this.submitPressed){
                return null
            }
            if(toString(this.year).trim() ==='' 
            || toString(this.month).trim() ==='' 
            || toString(this.day).trim() ===''
            || toString(this.hour).trim() ===''
            || toString(this.minute).trim() ==='')
            return false
            let currentTime=new Date();
            let date='';
            date+=this.year+'-';
            if(this.month.length==1)date+='0';
            date+=this.month+'-';
            if(this.day.length==1)date+='0';
            date+=this.day+' ';
            if(this.hour.length==1)date+='0';
            date+=this.hour+':';
            if(this.minute.length==1)date+='0';
            date+=this.minute+':00';
            console.log("date:");
            console.log(date);
            let date1converted=Date.parse(currentTime);
            let date2converted=Date.parse(date);
            if(!date2converted){
                return false
            }
            console.log("former:");
            console.log(date1converted);
            console.log("latter:");
            console.log(date2converted);
            if(date1converted>date2converted){
                return false;
            }else if(date1converted===date2converted){
                return false;
            }
            // console.log("time ok");

            return true
        },
        vGoalNum(){
            if(!this.submitPressed){
                return null
            }
            if(parseInt(this.mission.goal) < 2 || parseInt(this.mission.goal) > 100000){
                return false 
            }
            return true
        },
        wordLeft(){
            return  140-this.mission.content.length;
        }
    },
    beforeRouteLeave(to, from, next){
        if(this.success){
            next();
            return 0
        }
        const answer = window.confirm("你确定要退出本页面吗？本页数据将不会被保存")
        if (answer) {
            next()
        } else {
            next(false)
        }
    },
    mounted(){
        let currentTime=new Date();
        this.year=currentTime.getFullYear();
        this.month=currentTime.getMonth()+1;
        this.day=currentTime.getDate();
        this.hour=currentTime.getHours();
        this.minute=currentTime.getMinutes();
    }
}
</script>

